import { Box, Stack, Text } from '@mantine/core';
import { Plus } from 'lucide-react';
import type { ReactElement } from 'react';

/**
 * The always-present "Add insight" tile in the custom-insights grid. Opens the
 * Add-insight modal where a visualization is configured (or described) and
 * pinned to the page.
 */
export default function AddTileCard({ onClick }: { onClick: () => void }): ReactElement {
    return (
        <Box
            component="button"
            type="button"
            onClick={onClick}
            aria-label="Add insight"
            style={{
                all: 'unset',
                cursor: 'pointer',
                display: 'block',
                height: '100%',
                boxSizing: 'border-box',
            }}
        >
            <Box
                style={{
                    height: '100%',
                    minHeight: 180,
                    border: '1px dashed var(--bm-color-border)',
                    borderRadius: 'var(--bm-radius)',
                    background: 'var(--bm-color-surface)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Stack align="center" gap={6}>
                    <Box
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: 'var(--bm-radius)',
                            background: 'var(--mantine-primary-color-light)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Plus size={20} style={{ color: 'var(--mantine-primary-color-filled)' }} />
                    </Box>
                    <Text fw={700} style={{ fontSize: '15px' }}>
                        Add insight
                    </Text>
                    <Text size="xs" c="dimmed">
                        Build a custom visualization
                    </Text>
                </Stack>
            </Box>
        </Box>
    );
}
